/**
 * BentoJsonLd — Iter84 extraction.
 *
 * In-app JSON-LD (Course + EducationalOccupationalCredential) for the
 * path view. Mirrors the SSR JSON-LD on /p/{slug} so crawlers that
 * still execute JS pick up the structured data on direct path-page
 * navigations. Pure data, zero state — exported as its own component
 * to keep BentoPath focused on layout + interactivity.
 */
export default function BentoJsonLd({ path }) {
  if (!path) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Course",
              name: path.goal,
              description: path.ai_summary || path.summary,
              provider: { "@type": "Organization", name: "Oak AI Campus", url: "https://oakaiapp.com/" },
              educationalLevel: path.difficulty_tier || "Intermediate",
              inLanguage: path.language || "en",
              hasPart: (path.steps || []).map((s, i) => ({
                "@type": "LearningResource",
                name: s.title,
                position: i + 1,
                educationalLevel: path.difficulty_tier || "Intermediate",
              })),
            },
            {
              "@type": "EducationalOccupationalCredential",
              name: `Oak AI Campus — ${(path.difficulty_tier || "Mastery").replace(/^./, (c) => c.toUpperCase())} Credential in ${path.goal}`,
              credentialCategory: "Open Badges 2.0 Digital Credential",
              recognizedBy: { "@type": "Organization", name: "Oak AI Campus", url: "https://oakaiapp.com/" },
              url: `https://oakaiapp.com/cert/`,
              validFor: "P3Y",
            },
          ],
        }),
      }}
    />
  );
}
